import { ComponentStyleConfig } from "@chakra-ui/react";

const DescriptionListTheme: ComponentStyleConfig = {
  baseStyle: {
    width: "100%",
    gap: "var(--mb-description-list-spacing)",
    "dt, dd": {
      _notLast: {
        mb: "var(--mb-description-list-spacing)",
      },
    },
    dt: {
      float: "left",
      clear: "left",
      mr: "var(--mb-description-list-spacing)",
      _after: {
        content: '":"',
      },
    },
  },
  sizes: {
    sm: {
      "--mb-description-list-spacing": "4px",
      textStyle: "small",
      dd: {
        textStyle: "smallBold",
      },
    },
    md: {
      "--mb-description-list-spacing": "8px",
      textStyle: "body",
      dd: {
        textStyle: "bodyBold",
      },
    },
  },
  defaultProps: {
    size: "md",
  },
};

export default DescriptionListTheme;
